import { HeartsContainer } from "./HeartsContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { HiLoCardsContainer } from "./HiLoCardsContainer";

export class HiLoHUD extends Phaser.GameObjects.Container {

    public static currentInstance: HiLoHUD;

    private heartsContainer: HeartsContainer;
    private creditsLabel: Phaser.GameObjects.Text;
    private scoreLabel: Phaser.GameObjects.Text;
    private scoreChip: Phaser.GameObjects.Image;
    private cardsCounterContainer: Phaser.GameObjects.Container;
    private cardsCounterLabel: Phaser.GameObjects.Text;

    private canUpdateScore: boolean;

    constructor(scene: Phaser.Scene) {

        super(scene);

        HiLoHUD.currentInstance = this;

        this.canUpdateScore = false;

        const topBackground = new Phaser.GameObjects.Graphics(this.scene);
        topBackground.fillStyle(0x000000, .75);
        topBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, 70);
        this.add(topBackground);

        this.heartsContainer = new HeartsContainer(this.scene);
        this.add(this.heartsContainer);

        // LOS CREDITOS
        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 + 30 * GameVars.scaleX, 32, GameVars.formatNumber(GameVars.gameData.chips), {fontFamily: "Oswald-Medium", fontSize: "46px", color: "#ffffff"});
        this.creditsLabel.setOrigin(1, .5);
        this.creditsLabel.scaleX = GameVars.scaleX;
        this.add(this.creditsLabel);

        let chipIcon = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 60 * GameVars.scaleX, 34, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(1.2 * GameVars.scaleX, 1.2);
        this.add(chipIcon);

        // score
        const scoreTitleLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 185, "SCORE:", {fontFamily: "Oswald-Medium", fontSize: "34px", color: "#25715d"});
        scoreTitleLabel.scaleX = GameVars.scaleX;
        scoreTitleLabel.setOrigin(1, .5);
        this.add(scoreTitleLabel); 

        this.scoreLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 + 90 * GameVars.scaleX, 185, "0", {fontFamily: "Oswald-Medium", fontSize: "34px", color: "#25715d"});
        this.scoreLabel.scaleX = GameVars.scaleX;
        this.scoreLabel.setOrigin(1, .5);
        this.add(this.scoreLabel); 

        this.scoreChip = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 115 * GameVars.scaleX, 185, "texture_atlas_1", "chip_pot_icon.png");
        this.scoreChip.setScale(.9 * GameVars.scaleX, .9);
        this.add(this.scoreChip);

        const rectWidth = 70;
        const rectHeight = 44;

        this.cardsCounterContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.cardsCounterContainer);

        let roundedRect = new Phaser.GameObjects.Graphics(this.scene);
        roundedRect.x = GameConstants.GAME_WIDTH / 2 + HiLoCardsContainer.DECK_PX * GameVars.scaleX;
        roundedRect.y = 400;
        roundedRect.scaleX = GameVars.scaleX;
        roundedRect.fillStyle(0x000000, .5);
        roundedRect.fillRoundedRect(-rectWidth / 2, -rectHeight / 2, rectWidth, rectHeight, rectHeight / 2);
        this.cardsCounterContainer.add(roundedRect); 

        this.cardsCounterLabel = new Phaser.GameObjects.Text(this.scene, roundedRect.x, roundedRect.y, GameVars.hiLoRemainingCards.toString(), {fontFamily: "Oswald-Medium", fontSize: "32px", color: "#89E09D"});
        this.cardsCounterLabel.setOrigin(.5);
        this.cardsCounterLabel.scaleX = GameVars.scaleX;
        this.cardsCounterContainer.add(this.cardsCounterLabel); 

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(): void {

        if (this.canUpdateScore) {

            if (parseInt(this.scoreLabel.text) > 0) {
                this.scoreLabel.setText((parseInt(this.scoreLabel.text) - 10) + "");
            } else {
                this.canUpdateScore = false;
            }

            let currentChips = this.creditsLabel.text.replace(",", "");

            if (parseInt(currentChips) < GameVars.gameData.chips) {
                this.creditsLabel.setText(GameVars.formatNumber(parseInt(currentChips) + 10));
            }
        }
    }

    public onGameOver(): void {
        
        this.hideOnComplete();
    }

    public onGameCompleted(): void {
        
        this.scene.time.addEvent({delay: 1500, callback: () => {
            this.canUpdateScore = true;
            this.moveChipIcon();
        }, callbackScope: this});
        
        this.hideOnComplete();
    }

    public moveChipIcon(): void {

        if (this.canUpdateScore) {
            let chipIcon = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 115 * GameVars.scaleX, 185, "texture_atlas_1", "chip_pot_icon.png");
            chipIcon.setScale(.9 * GameVars.scaleX, .9);
            this.add(chipIcon);

            this.scene.tweens.add({
                targets: chipIcon,
                x: GameConstants.GAME_WIDTH / 2 + 60 * GameVars.scaleX,
                y: 32,
                scaleX: GameVars.scaleX,
                scaleY: 1,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 200,
                onComplete: () => {
                    chipIcon.destroy();
                    this.moveChipIcon();
                }, 
                onCompleteScope: this
            });

            this.scene.tweens.add({
                targets: this.scoreChip,
                scaleX: GameVars.scaleX,
                scaleY: 1,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 200,
                yoyo: true
            });
        }
    }

    public hideOnComplete(): void {

        this.scene.tweens.add({
            targets: [this.heartsContainer, this.cardsCounterContainer],
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 500
        });
    }

    public onReplay(): void {

        this.heartsContainer.alpha = 1;
        this.cardsCounterContainer.alpha = 1;

        this.updateHearts();
        this.updateScore();
        this.updateCardsCounter();
        
        this.canUpdateScore = false;
    }

    public updateHearts(): void {

        this.heartsContainer.updateHearts();
    }

    public updateExtraHearts(): void {

        this.heartsContainer.updateExtraHearts();
    }

    public updateScore(): void {

        this.scoreLabel.text = GameVars.hiLoScore.toString();
    }

    public showPlusPointsLabel(): void {

        const plusOneLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 350, "+100", {fontFamily: "Oswald-Medium", fontSize: "40px", color: "#66ff66"});
        plusOneLabel.setStroke("#25715d", 8);
        this.add(plusOneLabel); 

        this.scene.tweens.add({
            targets: plusOneLabel,
            y: 275,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500
        });

        this.scene.tweens.add({
            targets: plusOneLabel,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 300,
            delay: 200,
            onComplete: function(): void {
                plusOneLabel.destroy();
            },
            onCompleteScope: this
        });
    }

    public showSubPointsLabel(): void {

        const plusOneLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 350, "-100", {fontFamily: "Oswald-Medium", fontSize: "40px", color: "#ff4a77"});
        plusOneLabel.setStroke("#af254b", 8);
        this.add(plusOneLabel); 

        this.scene.tweens.add({
            targets: plusOneLabel,
            y: 275,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500
        });

        this.scene.tweens.add({
            targets: plusOneLabel,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 300,
            delay: 200,
            onComplete: function(): void {
                plusOneLabel.destroy();
            },
            onCompleteScope: this
        });
    }

    public updateCardsCounter(): void {

        this.cardsCounterLabel.text = GameVars.hiLoRemainingCards.toString();
    }

    public updateCredits(): void {

        this.creditsLabel.text = GameVars.formatNumber(GameVars.gameData.chips);
    }
}
